import { render, staticRenderFns } from "./greenProject.vue?vue&type=template&id=46db00d0&scoped=true"
import script from "./greenProject.vue?vue&type=script&lang=js"
export * from "./greenProject.vue?vue&type=script&lang=js"
import style0 from "./greenProject.vue?vue&type=style&index=0&id=46db00d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46db00d0",
  null
  
)

export default component.exports